module.exports = __webpack_public_path__ + "static/img/homeBgPk.daa7944.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeBgPk.png
// module id = z/Vq
// module chunks = 1